/**
 * View component for /metrics/:metricId/update
 *
 * Updates a single metric from a copy of the selcted metric
 * as defined in the metric reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as metricActions from '../metricActions';
import * as metricCategoryActions from '../../metricCategory/metricCategoryActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import metric components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import MetricForm from '../components/MetricForm.js.jsx';

class UpdateMetric extends Base {
  constructor(props) {
    super(props);
    const { selectedMetric, metricMap } = this.props;
    this.state = {
      metric: metricMap[selectedMetric.id] ? { ...metricMap[selectedMetric.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , formHelpers: {
        hasLDO: metricMap[selectedMetric.id] && metricMap[selectedMetric.id].likelihoodDeviation ? 'yes' : 'no'
        , hasINC: metricMap[selectedMetric.id] && metricMap[selectedMetric.id].impactNonCompliance ? 'yes' : 'no'
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(metricActions.fetchSingleIfNeeded(match.params.metricId))
    dispatch(metricCategoryActions.fetchListIfNeeded('all'))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedMetric, metricMap } = nextProps;
    this.setState({
      metric: metricMap[selectedMetric.id] ? { ...metricMap[selectedMetric.id] } : {}
      //we don't want to actually change the store's metric, just use a copy
    })
  }

  _handleFormChange(e) {
    var newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    let updatedMetric = {...this.state.metric};
    if(this.state.formHelpers.hasLDO === 'no') {
      updatedMetric.likelihoodDeviation = null;
    } else {
      updatedMetric.likelihoodDeviation = parseInt(this.state.metric.likelihoodDeviation)
    }

    if(this.state.formHelpers.hasINC === 'no') {
      updatedMetric.impactNonCompliance = null;
    } else {
      updatedMetric.impactNonCompliance = parseInt(this.state.metric.impactNonCompliance)
    }
    dispatch(metricActions.sendUpdateMetric(updatedMetric)).then((action) => {
      if(action.success) {
        history.push(`/admin/authoring/metrics/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { location, selectedMetric, metricMap, metricCategoryStore } = this.props;
    const { metric } = this.state;
    const isEmpty = (!metric || metric.title === null || metric.title === undefined);

    // get the metricCategoryList meta info here so we can reference 'isFetching'
    const metricCategoryList = metricCategoryStore.lists ? metricCategoryStore.lists.all : null;
    const metricCategories = metricCategoryStore.util.getList("all");
    const categoriesEmpty = !metricCategories || !metricCategoryList;

    return  (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            {isEmpty
              ? (selectedMetric.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            : <MetricForm
                metric={metric}
                metricCategories={metricCategories}
                cancelLink={`/admin/authoring/metrics/${metric._id}`}
                formHelpers={this.state.formHelpers}
                formTitle="Update Metric"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

UpdateMetric.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedMetric: store.metric.selected
    , metricMap: store.metric.byId
    , metricCategoryStore: store.metricCategory
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateMetric)
);



// WEBPACK FOOTER //
// modules/metric/views/UpdateMetric.js.jsx